import { useState, useEffect, useCallback } from 'react';
import { differenceInSeconds } from 'date-fns';

export const useTimer = (time: number | Date, onComplete?: () => void) => {
  const getInitialTime = useCallback((): number => {
    return typeof time === 'number'
      ? time
      : Math.max(differenceInSeconds(new Date(time), new Date()), 0);
  }, [time]);

  const [remainingTime, setRemainingTime] = useState(getInitialTime);

  useEffect(() => {
    if (remainingTime <= 0) {
      onComplete?.();
      return;
    }

    const timer = setInterval(() => {
      setRemainingTime(prev => Math.max(prev - 1, 0));
    }, 1000);

    return () => clearInterval(timer);
  }, [remainingTime, onComplete]);

  const resetTimer = useCallback(() => {
    setRemainingTime(getInitialTime());
  }, [getInitialTime]);

  return { remainingTime, resetTimer };
};
